<template>
  <Layout>
    <section class="csms-hq">

      <!-- Page Title Start -->
      <PageHeader :title="title" />
      <!-- Page Title End -->

      <!-- Summary Start -->
      <div class="row">
        <div class="col-xl-3">
          <SummaryCard :title="$_formatter.convertedTitle('headquarters', 'hqStatus')"
                       :items="[
                         { name: $t('common.total'), value: infoItems.hqStatusTotal },
                         // { name: $t('common.newToday'), value: infoItems.hqStatusNewToday }
                       ]" />
        </div>
        <div class="col-xl-3">
          <SummaryCard :title="$_formatter.convertedTitle('headquarters', 'cpStatus')"
                       :items="[
                         { name: $t('common.total'), value: infoItems.cpStatusTotal },
                         // { name: $t('common.newToday'), value: infoItems.cpStatusNewToday }
                       ]" />
        </div>
        <div class="col-xl-6">
          <SummaryCard :title="$_formatter.convertedTitle('headquarters', 'cbStatus')"
                       :items="cbCountItems" />
        </div>
      </div>
      <!-- Summary End -->

      <!-- Search Area Start -->
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">

              <div class="row">
                <!-- // Search Input -->
                <div class="col-xl-10 ion-mb-mb-100">
                  <div class="row">
                    <div class="col-xl-3" v-if="$_app.user.roles[0] === 'ADMIN'">
                      <label class="form-label" for="hq-search-hq">{{ $t('common.headquarters') }}</label>
                      <multiselect id="hq-search-hq"
                                   v-model="searchForm.hqId"
                                   label="text" track-by="value"
                                   :options="hqOptions"
                                   selectLabel=""
                                   selectedLabel=""
                                   deselectLabel=""
                                   :searchable="false" :allow-empty="false" />
                    </div>
                    <div class="col-xl-3">
                      <label class="form-label" for="hq-search-representative-name">{{ $t('headquarters.hqRepresentAccountName') }}</label>
                      <input type="text" class="form-control" id="hq-search-representative-name"
                             v-model="searchForm.hqRepresentAccountName" />
                    </div>
                    <div class="col-xl-3">
                      <label class="form-label" for="hq-search-representative-id">{{ $t('headquarters.hqRepresentAccountEmail') }}</label>
                      <input type="text" class="form-control" id="hq-search-representative-id"
                             v-model="searchForm.hqRepresentAccountEmail" />
                    </div>
                  </div>
                </div>
                <!-- // Search Button -->
                <div class="col-xl-2 align-content-end">
                  <div class="float-end">
                    <b-button variant="secondary" class="me-3" @click="reset">
                      <i class="uil uil-redo me-2"></i>
                      <span>{{ $t('btn.reset') }}</span>
                    </b-button>
                    <b-button variant="primary" @click="search">
                      <i class="uil uil-search me-2"></i>
                      <span>{{ $t('btn.search') }}</span>
                    </b-button>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!-- Search Area End -->

      <!-- List Start -->
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">

              <div class="row mb-3 align-items-end">
                <!-- // List PerPage Count -->
                <div class="col-auto">
                  <PerPageSelector v-model="pagination.perPage"
                                   :option="[50, 100, 200]"
                                   @change="onPerPageChange" />
                </div>
                <!-- // Total Count -->
                <div class="col me-2">
                  <div class="float-end">
                    <total-count :total-count="pagination.totalCount" />
                  </div>
                </div>
              </div>

              <!-- // List -->
              <div class="table-responsive">
                <b-table class="text-nowrap align-middle" bordered hover
                         thead-class="align-middle"
                         show-empty :empty-text="$t('headquarters.noHq')"
                         :fields="fields" :items="items">
                  <template #head()="data">
                    <div v-if="!$_utils.isEmpty(data.label)">
                      <span>{{ $t(`headquarters.${data.column}`) }}</span>
                    </div>
                    <div v-if="data.column === 'slowPrice' || data.column === 'fastPrice'">
                      <span>(¥/kWh)</span>
                    </div>
                  </template>

                  <template #cell(hqRepresentAccountName)="data">
                    {{ !$_utils.isEmpty(data.item.hqRepresentAccountName) ? data.item.hqRepresentAccountName : '-' }}
                  </template>
                  <template #cell(hqRepresentAccountEmail)="data">
                    {{ !$_utils.isEmpty(data.item.hqRepresentAccountEmail) ? data.item.hqRepresentAccountEmail : '-' }}
                  </template>
                  <template #cell(address)="data">
                    {{ $_utils.textLengthOverCut(data.item.address, 40, null) }}
                  </template>
                  <template #cell(slowPrice)="data">
                    {{ !$_utils.isEmpty(data.item.paymentUnitPrice) ? data.item.paymentUnitPrice.slowSellingPrice.toLocaleString() : '-' }}
                  </template>
                  <template #cell(fastPrice)="data">
                    {{ !$_utils.isEmpty(data.item.paymentUnitPrice) ? data.item.paymentUnitPrice.fastSellingPrice.toLocaleString() : '-' }}
                  </template>
                  <template #cell(etc)="data">
                    <router-link role="button"
                                 :to="{path: `/hq/view/${data.item.id}`}"
                                 class="btn btn-sm btn-outline-primary w-sm">{{ $t('btn.view') }}</router-link>
                  </template>
                </b-table>
              </div>

              <!-- // Pagination -->
              <div class="row mt-3">
                <div class="col-xl-12">
                  <b-pagination size="sm" class="mb-0" align="center"
                                :total-rows="pagination.totalCount"
                                :per-page="pagination.perPage"
                                v-model="pagination.currentPage"
                                @change="onPageChange" />
                </div>
              </div>

              <div class="row" v-if="$_app.user.roles[0] === 'ADMIN'">
                <div class="col-xl-6"></div>
                <div class="col-xl-6">
                  <div class="float-end">
                    <b-button variant="success" @click="create">
                      <i class="uil uil-plus me-2"></i>
                      <span>{{ $t('btn.create') }}</span>
                    </b-button>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!-- List End -->

      <create-modal ref="hqCreateModal" @callback="getItems" />
    </section>
  </Layout>
</template>

<script>
import { http } from '@/auth-api';
import { loadingMethods } from '@/state/helpers';
import i18n from '@/i18n';
import Swal from 'sweetalert2';
import Multiselect from 'vue-multiselect';
import Layout from '@/views/layouts/Main.vue';
import PageHeader from '@/components/PageHeader.vue';
import PerPageSelector from '@/views/components/PerPageSelector.vue';
import TotalCount from '@/views/components/TotalCount.vue';
import SummaryCard from '@/views/components/SummaryCard.vue';
import CreateModal from '@/views/pages/headquarters/HqCreateModal.vue';

export default {
  components: {
    Multiselect, Layout, PageHeader, PerPageSelector, TotalCount, SummaryCard, CreateModal
  },
  data() {
    return {
      title: 'headquarters',
      searchConditions: [],
      sortDirection: 'DESC',
      pagination: {
        currentPage: 1,
        totalCount : 0,
        perPage: 50
      },
      infoItems: {
        hqStatusTotal: 0,
        hqStatusNewToday: 0,
        cpStatusTotal: 0,
        cpStatusNewToday: 0,
        cbStatusTotal: 0,
        slow: 0,
        fast90: 0,
        fast120: 0,
        fast180: 0
      },
      cbCountItems: [],
      hqOptions: [],
      searchForm: {
        hqId: { text: i18n.t('common.total'), value: null },
        hqRepresentAccountName: null,
        hqRepresentAccountEmail: null
      },
      fields: [
        { key: 'rnum', label: 'No.', class: 'text-center' },
        { key: 'hqName', label: '사업 본부명', class: 'text-center' },
        { key: 'address', label: '주소' },
        { key: 'hqRepresentAccountName', label: '대표 담당자명', class: 'text-center' },
        { key: 'tel', label: '전화 번호', class: 'text-center' },
        { key: 'hqRepresentAccountEmail', label: '대표 담당자 ID', class: 'text-center' },
        { key: 'slowPrice', label: '완속 요금', class: 'text-center' },
        { key: 'fastPrice', label: '급속 요금', class: 'text-center' },
        { key: 'created', label: '등록일', class: 'text-center' },
        { key: 'etc', label: '', class: 'text-center' }
      ],
      items: null
    }
  },
  mounted() {
    const vm = this;

    vm.getHqOptions();

    vm.showOverlay();
    vm.getItems();
  },
  methods: {
    ...loadingMethods,
    getHqOptions() {
      const vm = this;
      const _url = '/onmapi/view/Hq/listAll';

      http.get(_url, {}).then(res => {
        vm.hqOptions = [{ text: i18n.t('common.total'), value: null }];

        res.data.items.forEach(item => {
          vm.hqOptions.push({text: item.hqName, value: item.id});
        });
      }).catch(err => {
        console.error('Headquarters List Data Error :: ', err)
      });
    },
    async getItems() {
      const vm = this;

      await Promise.all([
        vm.getInfoItems(),
        vm.getListItems()
      ]);
      vm.hideOverlay();
    },
    reset() {
      const vm = this;

      vm.searchForm = {
        hqId: { text: i18n.t('common.total'), value: null },
        hqRepresentAccountName: null,
        hqRepresentAccountEmail: null
      };
      vm.searchConditions = [];

      vm.getListItems();
    },
    search() {
      const vm = this;

      vm.searchConditions = [];

      if (!this.$_utils.isEmpty(vm.searchForm.hqId.value)) {
        vm.searchConditions.push({ searchKey: 'hqName', searchValue: vm.searchForm.hqId.text });
      }

      if (!this.$_utils.isEmpty(vm.searchForm.hqRepresentAccountName)) {
        vm.searchConditions.push({ searchKey: 'hqRepresentAccountName', searchValue: vm.searchForm.hqRepresentAccountName });
      }

      if (!this.$_utils.isEmpty(vm.searchForm.hqRepresentAccountEmail)) {
        vm.searchConditions.push({ searchKey: 'hqRepresentAccountEmail', searchValue: vm.searchForm.hqRepresentAccountEmail });
      }

      vm.pagination.currentPage = 1;
      vm.getListItems();

      /*if (this.$_utils.isEmpty(vm.searchForm.hqId.value)
          && this.$_utils.isEmpty(vm.searchForm.hqRepresentAccountName)
          && this.$_utils.isEmpty(vm.searchForm.hqRepresentAccountEmail)) {
        Swal.fire({
          icon: 'warning',
          title: i18n.t('alert.searchConditions'),
          confirmButtonText: i18n.t('btn.close')
        });
      } else {
        vm.searchConditions = [];

        if (!this.$_utils.isEmpty(vm.searchForm.hqId.value)) {
          vm.searchConditions.push({ searchKey: 'hqName', searchValue: vm.searchForm.hqId.text });
        }

        if (!this.$_utils.isEmpty(vm.searchForm.hqRepresentAccountName)) {
          vm.searchConditions.push({ searchKey: 'hqRepresentAccountName', searchValue: vm.searchForm.hqRepresentAccountName });
        }

        if (!this.$_utils.isEmpty(vm.searchForm.hqRepresentAccountEmail)) {
          vm.searchConditions.push({ searchKey: 'hqRepresentAccountEmail', searchValue: vm.searchForm.hqRepresentAccountEmail });
        }

        vm.pagination.currentPage = 1;
        vm.getListItems();
      }*/
    },
    getInfoItems() {
      const vm = this;
      const _url = '/onmapi/view/Summary/hq';

      return new Promise((resolve, reject) => {
        http.get(_url).then(res => {
          const _item = res.data.item;
          vm.infoItems = {
            ...vm.infoItems,
            hqStatusTotal: _item.hqTotalCount,
            hqStatusNewToday: _item.hqTodayCount,
            cpStatusTotal: _item.placeTotalCount,
            cpStatusNewToday: _item.placeTodayCount,
            cbStatusTotal: _item.chargePointTotalCount,
          }
          vm.cbCountItems = [
            { name: this.$t('common.total'), value: vm.infoItems.cbStatusTotal, divide: true },
            ...vm.createCbItem(i18n.t('common.slow'), _item.slowDetailCount),
            ...vm.createCbItem(i18n.t('common.fast'), _item.fastDetailCount)
          ];
          resolve(res);
        }).catch(err => {
          console.error('Member List Error :: ', err)
          reject(err);
        });
      });
    },
    getListItems() {
      const vm = this;
      const _url = '/onmapi/view/Hq/list';

      return new Promise((resolve, reject) => {
        http.post(_url, {
          page: vm.pagination.currentPage,
          limit: vm.pagination.perPage,
          searchConditions: vm.searchConditions,
          sortCondition: { sortDirection: vm.sortDirection }
        }).then(res => {
          vm.items = res.data.items;
          vm.pagination.totalCount = res.data.totalCount;
          resolve(res);
        }).catch(err => {
          console.error('Headquarters List Error :: ', err)
          reject(err);
        });
      });
    },
    createCbItem(chargerType, items) {
      return items.map(ele => ({
        name: `${chargerType} ${ele.maxKw}kW`,
        value: ele.count
      }));
    },
    async onPerPageChange() {
      const vm = this;

      if (vm.pagination.totalCount > 1) {
        vm.pagination.currentPage = 1;
        vm.showOverlay();
        await vm.getListItems();
        vm.hideOverlay();
      }
    },
    async onPageChange(val) {
      const vm = this;
      vm.pagination.currentPage = val;

      if (vm.pagination.totalCount > 1) {
        vm.showOverlay();
        await vm.getListItems();
        vm.hideOverlay();
      }
    },
    create() {
      const vm = this;

      vm.$nextTick(() => {
        this.$refs.hqCreateModal.show();
      });
    }
  }
}
</script>
